import useAuth, { Auth } from './useAuth';
import { showModal } from '../actions/uiActions';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import usePrevious from './usePrevious';

export function isAuthorized(auth: Auth) {
    const userId = auth.user ? auth.user.id : 0;
    return !!(auth.user && userId !== 0);
}

const useAuthCallback = (
    callback: (...args: any[]) => any,
    redirectOnAuth?: string,
    onLoginSuccess?: () => void,
    loginModalPriority?: number
) => {
    const dispatch = useDispatch();

    const auth = useAuth();

    const userId = auth.user ? auth.user.id : 0;

    const authorized = isAuthorized(auth);

    const moveToLogin = () => {
        dispatch(
            showModal('LOGIN', loginModalPriority || 0, {
                redirectOnAuth,
            })
        );
    };

    const prevUserState = usePrevious(auth.user);

    useEffect(
        () => {
            if (auth.user && !prevUserState) {
                // logged in
                onLoginSuccess && onLoginSuccess();
            }
        },
        [userId, auth.pending]
    );

    return authorized ? callback : moveToLogin;
};

export default useAuthCallback;
